// Default group for the analytics. For now, it will be an empty string.
export const DEFAULT_GROUP = '';
